import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type BottomSheetProps,
} from "@clipboard-health/ui-components";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";

import { type OnboardingPersonalIdVerificationAnalytics } from "./types";

type PersonalIdVerificationApprovedWithFlaggedNameBottomSheetProps = {
  isLoading: boolean;
  onContinue: () => void;
  analytics: OnboardingPersonalIdVerificationAnalytics;
} & Pick<BottomSheetProps, "modalState" | "canDismiss" | "paperSx">;

export function PersonalIdVerificationApprovedWithFlaggedNameBottomSheet(
  props: PersonalIdVerificationApprovedWithFlaggedNameBottomSheetProps
) {
  const { canDismiss, modalState, paperSx, isLoading, onContinue, analytics } = props;

  useLogEffect(
    APP_V2_APP_EVENTS.ONBOARDING_PERSONAL_ID_APPROVED_WITH_FLAGGED_NAME_BOTTOM_SHEET_VIEWED,
    {
      ...analytics,
    }
  );

  return (
    <BottomSheet
      canDismiss={canDismiss}
      modalState={modalState}
      paperSx={paperSx}
      footer={
        <DialogFooter orientation="vertical">
          <LoadingButton
            fullWidth
            isLoading={isLoading}
            size="large"
            onClick={() => {
              onContinue();
            }}
          >
            Continue
          </LoadingButton>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="check"
        title="We've received your note"
        description="Your ID has been verified, and our Operations team will update your name in the app to match your ID. You don't need to do anything else."
      />
    </BottomSheet>
  );
}
